import React from "react";
import styled from "styled-components";

import SectionHeader from "./SectionHeader";

interface SizeChartProps {
  sizes: (number | string)[];
  numPerRow: number;
}

const SizeChart = (props: any) => {
  const { sizes, numPerRow } = props;
  return (
    <>
      <SectionHeader title={"Select Size"} fontSize={22} />
      <GridContainer sizes={sizes} numPerRow={numPerRow}>
        {sizes.map((size: string | number, index: number) => (
          <Size key={size}>{size}</Size>
        ))}
      </GridContainer>
    </>
  );
};

const GridContainer = styled.div<SizeChartProps>`
  display: grid;
  width: 500px;
  height: ${(p) => `${66 * Math.ceil(p.sizes.length / p.numPerRow)}px`};
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: ${(p) =>
    `repeat(${Math.ceil(p.sizes.length / p.numPerRow)}, 48px)`};
  grid-gap: 0.5rem;
`;

const Size = styled.div`
  box-shadow: rgb(229 229 229) 0px 0px 0px 1px;
  border-radius: 4px;
  font-size: 20px;
  color: #6e6e6e;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export default SizeChart;
